import { render } from "./textarea.vue?vue&type=template&id=9358bb3c&scoped=true"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import "./textarea.vue?vue&type=style&index=0&id=9358bb3c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9358bb3c"],['__file',"src/views/form/components/textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9358bb3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9358bb3c', __exports__)) {
    console.log('reload')
    api.reload('9358bb3c', __exports__)
  }
  
  module.hot.accept("./textarea.vue?vue&type=template&id=9358bb3c&scoped=true", () => {
    console.log('re-render')
    api.rerender('9358bb3c', render)
  })

}


export default __exports__